import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArEH: CultureInfo = {
  name: 'ar-EH',
  displayName: 'العربية (الصحراء الغربية)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-EH',
  parent: CultureInfoAr
};
